import React, { useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { resetPassword } from "../services/LoginService";

export default function ChangePasswordPage() {

    const { token } = useParams();
    const [searchParams] = useSearchParams();
    const email = searchParams.get("email");

    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== passwordConfirm) {
            toast.error("Les mots de passe ne correspondent pas");
            return;
        }

        setIsLoading(true);

        const formData = {
            email,
            token,
            password,
            password_confirmation: passwordConfirm
        };

        try {

            const result = await resetPassword(formData);

            if (result.success) {
                toast.success(result.message);

                setPassword("");
                setPasswordConfirm("");

            } else {
                toast.error(result.message);
            }

        } catch (err) {
            toast.error("Erreur lors du changement du mot de passe");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Navbar />

            <main className="min-h-screen bg-black py-16 lg:px-4 px-2 lg:pt-28 pt-20">
                <div className="max-w-3xl mx-auto bg-color6 shadow-lg rounded-2xl lg:p-8 p-4">

                    <h1 className="lg:text-3xl text-xl font-bold text-color2 mb-4 text-center font-Poppins">
                        Changer votre mot de passe
                    </h1>

                    <p className="text-color2 text-center lg:mb-8 mb-4">
                        Entrez votre nouveau mot de passe pour sécuriser votre compte.
                    </p>

                    <form onSubmit={handleSubmit} className="space-y-5">

                        <div>
                            <label className="block text-color2 font-medium mb-1">
                                Nouveau mot de passe
                            </label>

                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-color1 text-black"
                            />
                        </div>

                        <div>
                            <label className="block text-color2 font-medium mb-1">
                                Confirmer le mot de passe
                            </label>

                            <input
                                type="password"
                                value={passwordConfirm}
                                onChange={(e) => setPasswordConfirm(e.target.value)}
                                required
                                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-color1 text-black"
                            />
                        </div>

                        <div className="text-center">
                            <button
                                type="submit"
                                disabled={isLoading}
                                className={`bg-color1 text-white font-semibold px-6 py-2 rounded-lg  transition duration-200 ${isLoading ? "opacity-70 cursor-not-allowed" : ""}`}
                            >
                                {isLoading ? "Modification..." : "Changer le mot de passe"}
                            </button>
                        </div>

                    </form>

                    <ToastContainer />

                </div>
            </main>

            <Footer />
        </>
    );
}